
import { useI18n } from '@/utils/i18n';
import { defineComponent , ref} from "vue";

export default defineComponent({
  name: "LoginTab",
  components: {},
 

  setup(prop,context) {
    const lan: any = useI18n();
    const selected=ref(1)
    function tabchange(e: number): void{
        selected.value=e
        context.emit("sel",e)

    }
    return {
      selected,
      tabchange,
      lan
    };
  },
});
